import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { CustomTabs } from './CustomTabs';

export default react2angular(CustomTabs, [
  'selectedTabId',
  'onChange',
  'tabItems',
  'fitContent'
]);
